import React, { type RefObject, type PropsWithChildren } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { Point, Size } from './toPortInfo.tsx';
import { calculateViewBox } from './isEveryPropertyDefined.tsx';
import { useDraggableDataAttributes } from './useCanvasDragDropEvents.tsx';

interface Props {
	rootSvgRef: RefObject<SVGSVGElement>;
	zoom: number;
	pan: Point;
	diagramSize: Size;
}

export const CanvasSvg = ({
	rootSvgRef,
	children,
	diagramSize,
	pan,
	zoom,
}: PropsWithChildren<Props>): React.JSX.Element => {
	const dataAttributes = useDraggableDataAttributes('pan');
	const viewBox = calculateViewBox(diagramSize, pan, zoom);

	return (
		<StyledSvg
			ref={rootSvgRef}
			{...dataAttributes}
			width={diagramSize.width}
			height={diagramSize.height}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox={`${viewBox.left} ${viewBox.top} ${viewBox.width} ${viewBox.height}`}
			preserveAspectRatio="xMinYMin"
			data-testid="accessible-workflow-diagram.svg-root"
		>
			{children}
		</StyledSvg>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledSvg = styled.svg({
	overflow: 'hidden',
	verticalAlign: 'middle',
	backgroundColor: token('elevation.surface'),
	userSelect: 'none',
});
